/**
 * Frontend entry point.
 *
 * Loads all proton scripts, images, and fonts via webpack require.context.
 * Pattern-level assets (atoms/molecules/organisms) are loaded separately
 * by PatternLoader, which enqueues only what is needed for the current page.
 */

/**
 * Import all matching modules from a webpack require.context.
 * @param {__WebpackModuleApi.RequireContext} r - webpack require context
 * @return {void}
 */
function importScripts(r) {
  r.keys().forEach(r);
}

// OLD: Import all patterns into main bundle (commented out to enable pattern splitting)
// importScripts(require.context('./design-system/patterns/', true, /index\.js$/));

// NEW: Only import protons (global styles/scripts)
// Patterns (atoms, molecules, organisms, templates, pages) are now loaded conditionally
// Each pattern is built as a separate webpack entry point (see webpack.config.js lines 26-46)
// pattern-loader.php enqueues only the patterns needed for each page
importScripts(
  require.context(
    '../design-system/patterns/00-protons/',
    true,
    /index\.js$/
  )
);

/**
 * Import all matching image files from a webpack require.context.
 * @param {__WebpackModuleApi.RequireContext} r - webpack require context
 * @return {void}
 */
function importImages(r) {
  r.keys().forEach(r);
}
importImages(
  require.context(
    '../design-system/patterns/00-protons/img/',
    true,
    /\.(?:ico|gif|png|jpg|jpeg|svg)$/i
  )
);

/**
 * Import all matching font files from a webpack require.context.
 * @param {__WebpackModuleApi.RequireContext} r - webpack require context
 * @return {void}
 */
function importFonts(r) {
  r.keys().forEach(r);
}
importFonts(
  require.context(
    '../design-system/patterns/00-protons/fonts/',
    true,
    /\.(woff(2)?|eot|ttf|otf|svg|)$/
  )
);
